import { useState, useEffect } from 'react';
import get from 'lodash/get';
import omit from 'lodash/omit';
import MESSAGE_TYPES from '../constants/MESSAGE_TYPES';
import Messager from '../lib/messager';
import { ITicket } from '../types/ticket';
import { CATEGORIES_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import type { ITicketsController } from '../lib/widget/tickets/tickets.interface';
import { useInjection } from 'inversify-react';
import { TICKETS_MODULE_IDS } from '../lib/widget/tickets/tickets.types';

const useCategoryModal = () => {
  const ticketsController: ITicketsController = useInjection(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);
  const [state, setState] = useState({
    category: null,
    count: 0,
  });
  useEffect(() => {
    window.Widget.categoriesController.addListener(CATEGORIES_EVENTS.SHOW_MODAL, showModal);
    window.Widget.categoriesController.addListener(CATEGORIES_EVENTS.ADD, updateCount);
    ticketsController.addListener(ticketsController.events.REMOVE, resetCount);
    return () => {
      window.Widget.categoriesController.removeListener(CATEGORIES_EVENTS.SHOW_MODAL, showModal);
      window.Widget.categoriesController.removeListener(CATEGORIES_EVENTS.ADD, updateCount);
      ticketsController.removeListener(ticketsController.events.REMOVE, resetCount);
    };
  }, []);

  const resetCount = (ticket: ITicket) => {
    if (state.category) {
      window.Widget.categoriesController.selectedCategories = omit(
        window.Widget.categoriesController.selectedCategories,
        [ticket.id],
      );

      setState((prevState) => ({
        ...prevState,
        count: 0,
      }));
    }
  };

  const showModal = () => {
    const id = window.Widget.categoriesController.selectedCategory;
    const category = window.Widget.categoriesController.categories[id];

    setState((prevState) => ({
      ...prevState,
      category,
      count: get(window.Widget.categoriesController.selectedCategories[id], 'count', 0),
    }));

    setTimeout(() => {
      try {
        if (window.getSelection) {
          if (window.getSelection().empty) {
            window.getSelection().empty();
          } else if (window.getSelection().removeAllRanges) {
            window.getSelection().removeAllRanges();
          }
          // @ts-ignore
        } else if (document.selection) {
          // @ts-ignore
          document.selection.empty();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }, 0);
  };

  const hide = () => {
    Messager.send({
      type: MESSAGE_TYPES.CHANGE_HELP_STATE,
      isOpen: false,
    });

    setState({
      category: null,
      count: 0,
    });
  };

  const handleChange = (_, count) => {
    const { id } = state.category;
    const value = get(window.Widget.categoriesController.selectedCategories[id], 'count', 0);

    setState((prevState) => ({
      ...prevState,
      count,
    }));

    if (count > value) {
      return window.Widget.categoriesController.add(id, count);
    }

    return window.Widget.categoriesController.remove(id, count);
  };

  const updateCount = () => {
    const id = window.Widget.categoriesController.selectedCategory;
    const count = get(window.Widget.categoriesController.selectedCategories[id], 'count', 0);

    setState((prevState) => ({
      ...prevState,
      count,
    }));
  };

  return { category: state.category, hide, handleChange };
};

export default useCategoryModal;
